import React from 'react'
import SettingsMetaData from '../../../../../Components/Hooks/useSettingsMetaData'

const Title = () => {
  return (
    <SettingsMetaData propertyName={"title_Activity"} viewPropertyName={"Title"} />

  )
}

export default Title